import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import Layout from "@/components/site/Layout";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { loginWithToken } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      loginWithToken(data.token, data.user);
      toast.success("Welcome back.");
      nav("/models");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-6 py-24">
        <div className="overline mb-4">Members · Sign in</div>
        <h1 className="font-serif-editorial text-5xl tracking-tighter mb-10">Enter the archive.</h1>
        <form onSubmit={submit} className="space-y-5">
          <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="Email"
            required data-testid="login-email"
            className="w-full bg-transparent border border-white/20 px-4 py-3 focus:border-white outline-none text-white placeholder:text-neutral-600"/>
          <input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Password"
            required data-testid="login-password"
            className="w-full bg-transparent border border-white/20 px-4 py-3 focus:border-white outline-none text-white placeholder:text-neutral-600"/>
          <button disabled={busy} type="submit" data-testid="login-submit" className="btn-white w-full justify-center">
            {busy ? "..." : "Sign in"}
          </button>
        </form>
        <div className="flex items-center gap-4 my-8">
          <div className="flex-1 h-px bg-white/10"/>
          <span className="text-xs text-neutral-500 font-mono-ui">OR</span>
          <div className="flex-1 h-px bg-white/10"/>
        </div>
        <button onClick={googleLogin} data-testid="login-google" className="btn-ghost w-full justify-center">
          Continue with Google
        </button>
        <div className="text-sm text-neutral-500 mt-8 text-center">
          No account? <Link to="/signup" className="text-white underline underline-offset-4">Join</Link>
        </div>
      </div>
    </Layout>
  );
}
